import CountdownTimer from '../countdown/CountdownTimer'
import { randomDelay, isPast } from './utils'
import { fetchNextService } from './api'
import { showStream, hideStream } from './view'

export default class LiveService {
  constructor({ element, liveEndDate, nextStartDate, nextEndDate, nextEmbed }) {
    this.element = element
    this.liveEndDate = liveEndDate
    this.nextStartDate = nextStartDate
    this.nextEndDate = nextEndDate
    this.nextEmbed = nextEmbed

    const isLive = liveEndDate !== ''

    if (isLive) {
      this.scheduleEndTimer()
    } else {
      this.scheduleStartTimer()
    }
  }

  scheduleStartTimer = () => {
    if(!this.nextStartDate) {
      console.log("There are no future live services scheduled.")
      this.hide()
      return
    }

    if (isPast(this.nextStartDate)) {
      console.log(`${this.nextStartDate} is in the past; not scheduling a timer`,)
      this.hide()
      return
    }

    console.log(`starting at ${this.nextStartDate}`)
    this.timer = new CountdownTimer(
      this.element,
      this.nextStartDate,
      this.startService,
    )
    this.timer.start()
  }

  scheduleEndTimer = () => {
    if (isPast(this.liveEndDate)) {
      console.log(`${this.liveEndDate} is in the past; not scheduling a timer`)
      return
    }

    console.log(`ending at ${this.liveEndDate}`)
    this.timer = new CountdownTimer(
      this.element,
      this.liveEndDate,
      this.endService,
    )
    this.timer.start()
  }

  startService = () => {
    showStream({ embed: this.nextEmbed })

    this.liveEndDate = this.nextEndDate
    this.scheduleEndTimer()

    randomDelay({
      callback: this.retrieveNextService,
      maxSeconds: this.nextServiceDelaySeconds(),
    })
  }

  nextServiceDelaySeconds = () => {
    const maxDelaySeconds = 10 * 60

    const serviceLengthMillis =
      new Date(this.nextEndDate).getTime() -
      new Date(this.nextStartDate).getTime()

    const serviceLengthSeconds = serviceLengthMillis / 1000

    return Math.min(maxDelaySeconds, serviceLengthSeconds)
  }

  retrieveNextService = () => {
    fetchNextService()
      .then((next) => {
        console.log('next service: ', { next })

        this.nextStartDate = next.startDate
        this.nextEndDate = next.endDate
        this.nextEmbed = next.embed
      })
      .catch((error) => {
        this.hide()
        console.error(`Error retrieving next service: ${error}`)
      })
  }

  endService = () => {
    hideStream()
    this.scheduleStartTimer()
  }

  hide = () => {
    this.element.parentNode.style.display = "none"
  }
}
